import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component specifically designed to scroll to top on route changes
 * Place this inside your Router but outside your Routes
 */
export const ScrollToTopOnRouteChange = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Force immediate scroll to top on route change
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      
      if (document.documentElement) {
        document.documentElement.scrollTop = 0;
      }
      if (document.body) {
        document.body.scrollTop = 0;
      }
    };

    // Execute immediately
    scrollToTop();
    
    // Also execute on next frame to handle any race conditions
    requestAnimationFrame(scrollToTop);
    
    // And one more time with timeout for stubborn cases
    const timeoutId = setTimeout(scrollToTop, 0);
    
    return () => clearTimeout(timeoutId);
  }, [pathname]);

  return null;
};

export default ScrollToTopOnRouteChange;
